module.exports = __webpack_public_path__ + "static/media/18ECA51.6fe85304.jpg";